// @flow
import ChatList from "./ChatList";

export default ChatList;
